import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { MOBILE_ROLES } from "@/lib/workflow";

export default function ProtectedRoute({ children, roles, permission, redirectMobile = true }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex items-center justify-center h-screen text-slate-500">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const hasPerm = permission && !!(user.permissions || {})[permission];
  if (roles && !roles.includes(user.role) && user.role !== "super_admin" && !hasPerm) {
    return <Navigate to="/" replace />;
  }
  if (redirectMobile && MOBILE_ROLES.includes(user.role) && !hasPerm) {
    return <Navigate to="/m" replace />;
  }
  return children;
}
